import type {
  ApiResponse,
  cancelSourcingApplicationSchema,
  PageResponse,
  SaveAndApplySourcingRequirementSchema,
  SourcingType,
  SrmSourcingApplicationItemDetail,
  SrmSourcingApplicationListItem,
  UpdateScourcingNodeSchema,
} from "@/types/apis";
import request from "@/utils/request";

/**
 * 寻源列表
 * @param data
 * @returns
 */
export const getSrmSourcingApplicationList = (data: any) =>
  request.post<PageResponse<SrmSourcingApplicationListItem>>(
    "/purchase/sourcing/application/pageList",
    data,
  );

/**
 * 获取寻源类别信息
 */
export const getSourcingTypeEnums = () =>
  request.get<ApiResponse<SourcingType[]>>(
    "/purchase/sourcing/application/getSourcingTypeEnums",
  );

/**
 *  保存并申请-寻源申请
 */
export const saveAndApplySourcingRequirement = (
  data: Partial<SaveAndApplySourcingRequirementSchema>,
) => request.post("/purchase/sourcing/application/saveAndApply", data);

/**
 * 根据ID获取寻源申请详情
 */
export const getSourcingRequirementDetail = (id: number) =>
  request.get<ApiResponse<SrmSourcingApplicationItemDetail>>(
    `/purchase/sourcing/application/detail/${id}`,
  );

/**
 * 删除寻源申请
 */
export const deleteSourcingRequirementRecord = (ids: number[]) =>
  request.post<ApiResponse>("/purchase/sourcing/application/delete", ids);

/**
 * 取消指定物料寻源
 */
export const cancelSourcingMaterial = (data: cancelSourcingApplicationSchema) =>
  request.post<ApiResponse>(`/purchase/sourcing/application/cancel`, data);

/**
 * 更新节点信息
 */
export const updateSourcingNode = (data: UpdateScourcingNodeSchema) =>
  request.post<ApiResponse>("/purchase/sourcing/application/updateNode", data);
